import { Box, Grid, Typography } from "@material-ui/core";
import LogoGroupForm from "./logoGroupForm";

export default function LogoGroupEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        Using Our Logo &gt; Edit Logo Group
        </Typography>
      </Box>
      <Grid container xs={6}>
        <LogoGroupForm
          description="Edit Group"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
